import { render } from "./survey.vue?vue&type=template&id=74d938fe"
import script from "./survey.vue?vue&type=script&lang=js"
export * from "./survey.vue?vue&type=script&lang=js"

import "./survey.vue?vue&type=style&index=0&id=74d938fe&lang=css"

import exportComponent from "/var/www/worldchatbox/node_build/worldchatbox_dev/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__